/**
 * The login screen's `redirect`, kept only when it names a page of this app or
 * the staff console. Anyone can put a link to this screen in a mail, and a
 * signed-in visitor is sent on to it at once: anything else would be an open
 * redirect, or a `javascript:` address run on this origin.
 */
export function signInReturnTo(redirect: unknown): string | undefined {
  if (typeof redirect !== 'string' || !redirect) {
    return undefined;
  }

  let url: URL;
  try {
    url = new URL(redirect, window.location.origin);
  } catch {
    return undefined;
  }

  if (!ownOrigins().includes(url.origin)) {
    return undefined;
  }

  /* Back to this screen names nowhere; the default destination does better. */
  if (url.origin === window.location.origin && url.pathname === '/login') {
    return undefined;
  }

  return url.href;
}

function ownOrigins(): string[] {
  const origins = [window.location.origin];
  const adminUrl: string | undefined = import.meta.env.VITE_ADMIN_URL;
  if (adminUrl) {
    origins.push(new URL(adminUrl).origin);
  }

  return origins;
}
